module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Outdoor-activity.6cc2eddb.jpg";